(function () {
  if (window.__promoCountdownInit) return;
  window.__promoCountdownInit = true;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function formatRemaining(ms) {
    var totalSeconds = Math.floor(ms / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  function initCountdown(el) {
    var start = new Date(el.dataset.start);
    var end = new Date(el.dataset.end);
    var timerEl = el.querySelector('[data-promo-timer]');

    function tick() {
      var now = new Date();

      if (now < start || now >= end) {
        el.hidden = true;
        return false; // stop
      }

      el.hidden = false;
      var remaining = end - now;
      if (timerEl) timerEl.textContent = formatRemaining(remaining);

      // Urgence progressive : normal → 6 dernières heures → dernière heure
      var ONE_HOUR = 60 * 60 * 1000;
      var SIX_HOURS = 6 * ONE_HOUR;
      el.classList.toggle('is-urgent', remaining <= SIX_HOURS && remaining > ONE_HOUR);
      el.classList.toggle('is-critical', remaining <= ONE_HOUR);

      return true; // continue
    }

    if (!tick()) return; // hors fenêtre dès le départ, rien à démarrer

    var interval = setInterval(function () {
      if (!tick()) clearInterval(interval);
    }, 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-promo-info]').forEach(initCountdown);
  });
})();